import {useState} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  useTheme,
  IconButton,
  Typography,
  TextareaAutosize,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';

export default function AppealStatementModal({ onCloseModal, isOpen, isLoading = false, onSendAppeal }) {
    const theme = useTheme();
    const [appealMsg, setAppealMsg] = useState('');

    const maxLength = 3000;

    const handleChange = (text) => {
      if (text.length <= maxLength) {
        setAppealMsg(text);
      }
    };
  
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={isLoading ? null : onCloseModal}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 1000,
          },
          content: {
            position: 'relative',
            paddingBottom: '0px',
            width: '800px',
            height: '625px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50.1%, -50.1%)',
            padding: '10px',
            borderRadius: '16px',
            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.3)',
            zIndex:9999,
          },
        }}
      >
        <div className="p-[24px]">
          <div className="flex justify-between mb-[24px]">
            <h1 className="text-[24px]">Appeal Statement</h1>
            <IconButton disabled={isLoading} onClick={onCloseModal} size="small" aria-label="edit">
              <CloseIcon color="inherit" />
            </IconButton>
          </div>
          <p className="text-[14px] mb-[24px]">
            If you believe the statement to be incorrect please describe your issue below and a member
            of the Roam Team will be in touch to handle your request.{' '}
          </p>
          <p 
            className='text-[13px] text-right mb-1'
            style={{color: appealMsg.length >= maxLength ? 'red' : ''}}
          >
            {appealMsg.length}/{maxLength}
            </p>
          <TextareaAutosize
            minRows={4}
            className="w-full border border-gray-300 rounded-md p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            label="Description of Issue"
            placeholder="Please describe your issue in full and add any dates where applicable"
            value={appealMsg}
            onChange={(e) => handleChange(e.target.value)}
            style={{
              width: '100%',
              height: '350px',
              maxHeight: '350px', 
              overflowY: 'auto',
              resize: 'none',   
            }}
          />
          <div className="flex justify-end gap-5">
            <Button
              disabled={isLoading}
              sx={{ borderRadius: 8, height: '40px', paddingX: '24px' }}
              variant="text"
              color="inherit"
              onClick={onCloseModal}
            >
              <Typography fontSize={14} textTransform={'none'}>
                Close
              </Typography>
            </Button>
  
            <Button
              disabled={isLoading}
              onClick={() => onSendAppeal(appealMsg)}
              sx={{
                color: 'white',
                backgroundColor: theme.palette.btnActiveColor,
                boxShadow: 'none',
                borderRadius: '25px',
                textTransform: 'none',
                ml: 1,
                '&.MuiButtonBase-root:hover': {
                  backgroundColor: theme.palette.btnActiveColor,
                  filter: 'brightness(0.9)',
                },
                px: 4,
              }}
              variant="contained"
            >
              <Typography fontSize={14} textTransform={'none'}>
                {isLoading ? 'Sending appeal...' : 'Send appeal'}
              </Typography>
            </Button>
          </div>
        </div>
      </Modal>
    );
  };
  
  AppealStatementModal.propTypes = {
    isOpen: PropTypes.bool,
    onCloseModal: PropTypes.func.isRequired,
    onSendAppeal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
  };